/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {Users} from '@ion/core/src/types/entities';
import {CellMenuItem} from '@ion/dls/src/grid/CellMenuItem';
import useMedia from '@ion/dls/src/hooks/useMedia';
import {MoveEntityIcon} from '@ion/dls/src/icons/MoveEntityIcon';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';
import {moveAdminUsers} from './state';

// defines the selections header styles ...
export const useStyles = makeStyles(theme => ({
  selectionsLabel : {
    ...dlsTypography('selectionsLabel')
  }
}));

// defines the user action menu prop definitions ...
export interface UsersActionMenuTypes {
  selectedUsers: Users;
  disableAction: boolean;
}

/**
 * Defines the UsersActionMenu component. This component contains
 * the row actions for User grid.
 */
export const UsersActionMenu = ({
  selectedUsers,
  disableAction
}: UsersActionMenuTypes) => {
  const dispatch  = useDispatch();
  const color     = dlsColor('white');
  const classes   = useStyles();
  const {isPhone} = useMedia();

  const onMove = useCallback(() => {
    dispatch(moveAdminUsers(selectedUsers, true));
  }, [selectedUsers]);

  return (
    <>
      <CellMenuItem customStyles={{root: classes.selectionsLabel}}
        icon={<MoveEntityIcon color={color} />}
        onClick={onMove}
        disabled={disableAction}
        label={!isPhone ? translate('admin-users:menu.move') : ''} />
    </>
  );
};
export default UsersActionMenu;
